export { WALLET_DRAWER_PT_BR } from "./wallet-drawer-pt-br";
export { WALLET_DRAWER_EN_US } from "./wallet-drawer-en-us";
export { WALLET_DRAWER_ES_MX } from "./wallet-drawer-es-mx";
export { WALLET_DRAWER_FR_FR } from "./wallet-drawer-fr-fr";
export type { WalletDrawerTranslations } from "./wallet-drawer-pt-br";
